import React from "react";
import '../MessageItem/MessageItem.scss';
import logoUser from '../../../../styles/svg_contacts/user-contact.svg';
import avatar_img from '../../../../styles/avatar_default.png';
import Config from "../../../../config/config";
import { confirmContact } from "../../../Authorization/authSlice";
import { showNotes, closeAllView, getInitialStateMenu, closeFirstContentView, showView, 
    getInitialStateWithPreviousView, setPreviousModule } from "../../../Menu/MenuSide/menuSideSlice";
//import { closeCategoryView } from "../../../Menu/MenuSide/menuSideSlice";
import { setSelectedNoteId, setSelectedNoteName } from "../../Notes/noteslice";
import { idNoteLoad } from "../../../Admin/adminSlice";
import { quizLoad, quizSetName, quizSetId } from "../../Quiz/quizSlice";
import logoNoteMessage from '../../../../styles/svg_messages/note_mes_data.svg';
import logoQuizMessage from '../../../../styles/svg_messages/quiz_mes_data.svg';
import logoAddContactMessage from '../../../../styles/svg_messages/new_contact_data.svg';

const MessageItem = (props) => {
 const  {dispatch} = props;
    const dataMessage = props.dataMessage;
    const dataNotes = props.dataNotes;

 //HANDLE CLICK BUTTON
 const onHandlerClickButton = () => {

    //IF CONFIRM CONTACT

   if (dataMessage.mesHref === 7) {
    const item = {
        userId: props.userId,
        contactId: dataMessage.user.id,
    }
    dispatch(confirmContact(item));
   }


    // ID SHOW QUIZ
   if (dataMessage.mesHref === 1) {


    console.log('WORK SHOW QUIZ');
    dispatch(closeAllView());

    const selectedQuizId = dataMessage.itemId;
    const selectedQuizName = dataMessage.title;

    dispatch(quizSetId(selectedQuizId));
    dispatch(quizSetName(selectedQuizName));
    dispatch(quizLoad(selectedQuizId));
    //dispatch(getInitialStateMenu());
   // dispatch(closeFirstContentView());
    dispatch(getInitialStateWithPreviousView());
            dispatch(setPreviousModule());
            dispatch(showView(3));
    
}



   //IF SHOW NOTE
   if (dataMessage.mesHref === 2) {
        console.log('WORK SHOW NOTES');
        dispatch(closeAllView());

        const selectedNoteId = dataMessage.itemId;
        const selectedNoteName = dataMessage.title;

        const findNote = (dataNotes) => {
            const result = dataNotes.findIndex(item => item.id === selectedNoteId);
            return result;
        };
        
        const noteExist = findNote(dataNotes);
       // console.log(typeof(noteExist));

        if (noteExist === -1) {

            console.log('Load NEW notes');

            dispatch(setSelectedNoteId(selectedNoteId));
            dispatch(setSelectedNoteName(selectedNoteName));
            dispatch(idNoteLoad(selectedNoteId));
           // dispatch(getInitialStateMenu());
           // dispatch(showNotes());
            dispatch(getInitialStateWithPreviousView());
            dispatch(setPreviousModule());
            dispatch(showView(33));
            
            
        } else {
            dispatch(setSelectedNoteId(selectedNoteId));
            dispatch(setSelectedNoteName(selectedNoteName));
           // dispatch(getInitialStateMenu());
            //dispatch(showNotes());
            dispatch(getInitialStateWithPreviousView());
            dispatch(setPreviousModule());
            dispatch(showView(33))
        }

   }
   
 }   




// ADD CONTACT BUTTON STYLE
    let buttonText = 'Открыть';
    
if (props.dataMessage.mesHref === 7) {
    buttonText = 'Добавить';
}

if ((Object.keys(dataMessage).length !== 0) || !dataMessage) {

   //AVATAR IMAGE
   const serverPath = Config.serverPath;
console.log(dataMessage);
   const avatarName = dataMessage.user.avatarName;
  // const avatarName = '';
   console.log(avatarName);
   //const userId = props.findContact[0].id?props.findContact[0].id:null ;
   let avatar_src = avatar_img;
   if (avatarName) {
          avatar_src = `${serverPath}/api/avatar/${dataMessage.user.id}/${avatarName}`;
   }


 //STYLE MESS HREF
 const mesHref = props.dataMessage.mesHref;
 let styleMesHref;
 
 if (mesHref === 1) {
    styleMesHref = logoQuizMessage;
};

if (mesHref === 2) {
    styleMesHref = logoNoteMessage; 
};
if (mesHref === 7) {
    styleMesHref = logoAddContactMessage; 
};








   //RENDER BODY MESSAGE
   const renderMessageItem = () => {
    
    

    return (
        <div className="mes-body">
            <div className="mes-header">
                <div className="mes-title">
                <img src={logoUser} alt='logo'/>
                <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                    <p className="user-nickname">{dataMessage.user.nickName}</p>
                </div>
                
                <span className="mes-data">{dataMessage.data}</span>
            </div>
            <div >
                <div className="mes-text"><p>{dataMessage.text}</p></div>
            </div>
            <div className="mes-href">
            <img className="logo-mes-href" src={styleMesHref} alt='logo'/>
                <p className="text-mesHref">{dataMessage.title}</p>

            </div>
            <button className="button-open" onClick={onHandlerClickButton}>{buttonText}</button>

        </div>
        )    
   }

   console.log(dataMessage);
   
   


        return (
            <div className="MessageItem">
                
                    {renderMessageItem()} 
                         

            </div>
        );   
   } else
    return null;
   
    
};
export default MessageItem;